export * from './lib/form-recaptcha.module';

export * from './lib/interfaces/recaptcha-form-field-config';
